import { CertificazioneCellulareUtenteDto, CertificazioneContattoDto, CertificazioneUtenteDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { ClienteReducerType } from "./types";

const clienteReducer = (state: RootState): ClienteReducerType => state.cliente;

export const accessTokenClienteSelector = createSelector(
  clienteReducer,
  (state: ClienteReducerType): string | undefined => state.tokenLoginUser
);

export const dettaglioCertificazioneClienteSelector = createSelector(
  clienteReducer,
  (state: ClienteReducerType): CertificazioneUtenteDto | undefined => {
    return state.dettaglioCertificazioneCliente;
  }
);

export const dettaglioSmsCertificazioneClienteSelector = createSelector(
  clienteReducer,
  (state: ClienteReducerType): CertificazioneCellulareUtenteDto | undefined => {
    return state.dettaglioSmsCertificazioneCliente;
  }
);

export const certificazioneContattoClienteSelector = createSelector(
  clienteReducer,
  (state: ClienteReducerType): CertificazioneContattoDto | undefined => {
    return state.certificazioneContattoCliente;
  }
);
